import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createAdminOrder } from "@/api/orderApi";

export default function AdminPaymentCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paymentId = searchParams.get("paymentId");
    const code = searchParams.get("code");
    const message = searchParams.get("message");

    if (code != null) {
      alert(`어드민 결제에 실패했습니다: ${message}`);
      navigate("/admin/orders/create");
      return;
    }

    const tempData = sessionStorage.getItem("ADMIN_ORDER_TEMP_DATA");
    if (!tempData) {
      alert("주문 정보를 찾을 수 없습니다. 다시 시도해주세요.");
      navigate("/admin/orders");
      return;
    }

    const payload = JSON.parse(tempData);

    const processAdminOrder = async () => {
      try {
        // 백엔드 연동 지원 시 impUid를 활용
        payload.impUid = paymentId;

        await createAdminOrder(payload);
        sessionStorage.removeItem("ADMIN_ORDER_TEMP_DATA");

        alert("결제 및 수기 주문서 등록이 완료되었습니다.");
        navigate("/admin/orders");

      } catch (error) {
        console.error("어드민 결제 콜백 에러:", error);
        alert("결제는 성공했으나, 주문서 생성 중 오류가 발생했습니다.");
        navigate("/admin/orders");
      }
    };

    if (paymentId) {
      processAdminOrder();
    }
  }, [navigate, searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-900 text-white font-bold text-xl">
      결제를 마무리하고 주문서를 등록 중입니다...
    </div>
  );
}